module.exports = __webpack_public_path__ + "static/media/thumbnail.2378063f.jpg";